import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import mapPropsToStyles from '../../utils/mapPropsToStyle';
import commonStyles from '../../styles/commonStyles';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    height: 100%;
    position: relative;
    ${commonStyles.veryDarkGray};
  }
`;

export const A = styled.a`
  ${(props) => mapPropsToStyles(props)};
`;

export const Div = styled.div`
  ${(props) => mapPropsToStyles(props)};

  &.wizard {
    &.horizontal {
      .steps-row {
        position: relative;
        display: flex;
        justify-content: space-around;
        justify-content: space-evenly;
        width: 100%;
        overflow: hidden;
        @supports (-ms-ime-align: auto) {
          & {
            justify-content: space-around;
          }
        }

        .steps-step {
          box-sizing: border-box;

          div {
            display: flex;
            flex-direction: column;

            p {
              margin-left: -10px;
              color: #444;
              font-size: 20px;
              position: relative;
              margin-top: 0;
              margin-bottom: 40px;

              &.active {
                color: #01a982;
                font-weight: 600;
              }
            }
          }
        }
        .rackSwitchedPage {
          div {
            p {
              margin-left: 9px;
            }
          }
          .Step5 {
            white-space: pre-wrap;
          }
        }
        button[disabled] {
          opacity: 1 !important;
          filter: alpha(opacity=100) !important;
        }

        a {
          text-decoration: none;
        }

        .btn {
          width: 22px;
          height: 22px;
          color: #fff;
          display: inline-block;
          border-radius: 50%;
          text-align: center;
          line-height: 1.5rem;
          box-sizing: border-box;
        }

        span.completed {
          background-color: #01a982 !important;
          color: #444;
          font-size: 20px;

          svg {
            height: 22px;
          }
        }

        span.inactive {
          border: 2px solid #e2e6ea;
          color: #444;
          font-size: 20px;
          background: white;
        }

        span.active {
          border: 2px solid #01a982;
          color: #444;
          font-size: 20px;
          color: #01a982;
          font-weight: 600;
          background: white;
          position: relative;

          .inner {
            position: absolute;
            background: #e2e6ea;
            border-radius: 50%;
            height: 12px;
            width: 12px;
            display: inline-block;
            top: 3px;
            right: 3px;
          }
        }
      }

      .steps-step.complete:before {
        top: 12px;
        bottom: 0;
        position: absolute;
        content: ' ';
        width: 100%;
        height: 2px;
        background-color: #01a982;
        z-index: -10;
      }

      .steps-row:before {
        top: 12px;
        bottom: 0;
        position: absolute;
        content: ' ';
        width: 100%;
        height: 2px;
        background-color: #01a982;
        z-index: -999;
      }

      .steps-step.incomplete:before {
        top: 12px;
        bottom: 0;
        position: absolute;
        content: ' ';
        width: 100%;
        height: 2px;
        background-color: #e2e6ea;
        z-index: -10;
      }
    }
    &.cloudenablement {
      .steps-row {
        .steps-step {
          div {
            p {
              margin-left: 2px !important;
              font-size: 16px !important;
            }
          }
        }
      }
      .steps-step.svtcloud {
        margin-left: 11px !important;
      }
      .steps-row:before {
        left: 35px;
        background-color: #ffffff;
      }
      .steps-step.incomplete:last-child:before {
        background-color: #fff !important;
      }
    }
    &.vertical {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      ul {
        margin-top: 0;
        margin-bottom: 0;
        margin-left: 0;
        padding-left: 20px;
        white-space: nowrap;
      }

      li {
        display: flex;
        align-items: flex-start;
        flex: 1;
        flex-direction: column;
        position: relative;
        height: 40px;

        a.link {
          text-decoration: none;
        }

        a.link:visited {
          text-decoration: none;
        }
        a.link:hover {
          text-decoration: none;
        }

        span.wrapper {
          align-self: flex-start;
          display: flex;
          position: relative;
          text-decoration: none;
          font-size: 0.88rem;
          text-align: left;

          span.label {
            color: #444;
            font-size: 18px;
            display: inline-block;
            vertical-align: top;
            max-width: 220px;
            white-space: normal;
            word-break: break-word;
            line-height: 1.3;
          }

          .circle {
            box-sizing: border-box;
            display: inline-block;
            color: #fff;
            border-radius: 50%;
            background: #fff;
            width: 11px;
            height: 11px;
            text-align: center;
            margin-right: 0.5rem;
            border: 2px solid #e2e6ea;
            position: relative;
            top: 1px;
          }

          .completed {
            span.circle {
              background-color: #01a982 !important;
              color: #444;
              font-size: 20px;
              border: none;
            }
          }

          .active {
            span.circle {
              border: 4px solid #01a982;
              color: #444;
              font-size: 20px;
              color: #01a982;
              background: #fff;
              position: relative;

              .inner {
                position: absolute;
                border-radius: 50%;
                height: 12px;
                width: 12px;
                display: inline-block;
                top: 3px;
                right: 3px;
              }
            }

            span.label {
              font-weight: 600;
            }
          }
        }
      }

      li:last-child {
        height: auto;
      }

      li:not(:last-child):after {
        content: '';
        position: absolute;
        width: 1px;
        height: calc(100% - 12px);
        left: 0.3rem;
        top: 20px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      li.completed:before {
        content: '';
        position: absolute;
        width: 1px;
        height: calc(100% - 12px);
        left: 0.3rem;
        top: 20px;
        background-color: #01a982 !important;
      }
    }
  }
  &.divider {
    height: 2px;
    width: 100%;
    border-top: 1px solid rgb(255, 255, 255);
    border-top: 1px solid rgba(255, 255, 255, 0.4);
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
  }
`;

export const Ul = styled.ul`
  ${(props) => mapPropsToStyles(props)};
`;

export const Li = styled.li`
  ${(props) => mapPropsToStyles(props)};
`;

export const P = styled.p`
  ${(props) => mapPropsToStyles(props)};
`;

export const Span = styled.span`
  ${(props) => mapPropsToStyles(props)};
`;

export const Img = styled.img`
  ${(props) => mapPropsToStyles(props)};

  &.landingLogo {
    width: 13.25rem;
    height: 1.75rem;
  }

  &.arrayModelIcon {
    width: 1.6875rem;
  }
`;

export const FeedbackFloat = styled.a`
  ${(props) => mapPropsToStyles(props)};

  background-color: #566676;
  height: 32px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 16px;
  color: #fff;
  transform-origin: 100% 100% 0;
  transform: rotate(-90deg);
  top: 33%;
  display: block;
  position: fixed;
  z-index: 99;
  right: -2px;
  cursor: pointer;
  &:hover {
    background-color: #425563;
  }
`;

export const VideoPlayerBox = styled.div`
  ${(props) => mapPropsToStyles(props)};

  ${commonStyles.marginBottom4};

  max-width: 640px;
  // max-height: 320px;
`;
/* The height of the item will now be 56.25% (9/16) of the width. */
//  padding-bottom: 53.75%;

export const IframeVideoWrapper = styled.div`
  ${(props) => mapPropsToStyles(props)};
  
  position: relative;
  width: 100%,
  height: 0;
  
  padding-bottom: ${(props) =>
    props.page === 'landing' ? '56.25%' : '56.25%'};
  display: ${(props) => (props.url ? 'block' : 'none')};;
  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border: none;    
  }
`;
